<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons" *ngIf="dataLoaded">{{title}}</h4>
</div>
<div class="modal-body">
    <div class="spinner" *ngIf="!dataLoaded"></div>
    <div class="validation--tabs" *ngIf="showValidationComponent">
        <validation-results [validationResults]="validationResults"></validation-results>
    </div>
    <ng-container *ngIf="dataLoaded">
        <div class="mvd_nav-tabs">
            <ul class="mvd_nav">
                <li role="presentation" [attr.aria-expanded]="isTabActive('Plates')">
                    <a href="javascript:void(0)" (click)="onTabChanged('Plates')">Plates</a>
                </li>
                <li role="presentation" [attr.aria-expanded]="isTabActive('Permit')">
                    <a href="javascript:void(0)" (click)="onTabChanged('Permit')">Permit</a>
                </li>
                <li role="presentation" [attr.aria-expanded]="isTabActive('VIN')">
                    <a href="javascript:void(0)" (click)="onTabChanged('VIN')">VIN</a>
                </li>
                <li role="presentation" [attr.aria-expanded]="isTabActive('Title')">
                    <a href="javascript:void(0)" (click)="onTabChanged('Title')">Title</a>
                </li>
                <li role="presentation" [attr.aria-expanded]="isTabActive('Registration')">
                    <a href="javascript:void(0)" (click)="onTabChanged('Registration')">Registration</a>
                </li>
            </ul>
        </div>
        <div class="well">
            <plate-search (onVehicleSelected)="itemSelected($event)" *ngIf="activeTab == 'Plates'"></plate-search>
            <permit-search (onVehicleSelected)="itemSelected($event)" *ngIf="activeTab == 'Permit'"></permit-search>
            <vehicle-generic-search [data]="data" [searchString]="searchString" (onVehicleSelected)="itemSelected($event)" [vehicleIdentType]="vehicleIdentTypes.VIN.id" *ngIf="activeTab == 'VIN'"></vehicle-generic-search>
            <vehicle-generic-search (onVehicleSelected)="itemSelected($event)" [vehicleIdentType]="vehicleIdentTypes.TitleNumber.id" *ngIf="activeTab == 'Title'"></vehicle-generic-search>
            <registration-search (onVehicleSelected)="itemSelected($event)" *ngIf="activeTab == 'Registration'"></registration-search>
        </div>
    </ng-container>
</div>
